import cn from 'bem-cn';

import { formatDateToShortRussian } from '../../../utils/date/date';
import { List, Stack, Tag, Video } from '../../UI';

import { ChallengeInfoHeaderProps } from './ChallengeInfoHeader.types';
import './ChallengeInfoHeader.scss';

const b = cn('challenge-info-header');

const renderTag = (item: string) => <Tag size="medium" text={item} />;
const extractTagKey = (item: string) => `tag-${item}`;

export const ChallengeInfoHeader = (props: ChallengeInfoHeaderProps) => {
    const { challenge, isChallengeActive } = props;
    const { title, description, deadline, videoData } = challenge;
    const { url: videoUrl, poster: videoPoster } = videoData;

    const formattedDeadline = formatDateToShortRussian(deadline);
    const tags = ['Челлендж', `${isChallengeActive ? 'До' : 'Завершён'} ${formattedDeadline}`];

    return (
        <Stack className={b()}>
            <Stack className={b('text-container')}>
                <List
                    direction="row"
                    justifyContent="center"
                    className={b('tags')}
                    items={tags}
                    renderItem={renderTag}
                    keyExtractor={extractTagKey}
                />
                <Stack spacing={8}>
                    <h1 className={b('title')}>{title}</h1>
                    <p className={b('description')}>{description}</p>
                </Stack>
            </Stack>
            <div className={b('video-container', { ended: !isChallengeActive })}>
                <Video
                    className={b('video')}
                    src={videoUrl}
                    poster={videoPoster}
                    autoPlay
                    muted
                    loop
                    playsInline
                    disablePictureInPicture
                    preload="auto"
                />
            </div>
        </Stack>
    );
};
